import React from 'react';
import { Helmet } from 'react-helmet';

const HelmetDefault = (props) => {
    
    return (
        <Helmet>
            <title>{props.seoTitle}</title>
            <meta name="description" content={props.seoDescription} />
        </Helmet>
    );
    
};

export default HelmetDefault;


// WEBPACK FOOTER //
// ./resources/assets/js/layout/HelmetDefault.js